import isISODate from "validator/lib/isISO8601";

export function isValidISO8601(val: string): boolean {
  return isISODate(val, { strict: true });
}

export const msgInvalidISO8601 = { message: "Not a valid ISO8601 date time" };
